<template>
  <!-- 翻唱类型 -->
  <div class="cover-type-song">
    <div class="part part-one">
      <div class="left" @click="handleClick">
        <img class="pic-area" :src="data.pic" alt="封面图片" />
        <!-- <button class="opt-icon" :class="playing ? 'icon-pause' : 'icon-play'" type="button" @click="toggleSong"></button> -->
      </div>
      <div class="right">
        <div class="avatar-area">
          <img class="avatar" :src="icon || 'https://aliimg.changba.com/!/activity2023/come_sing_with_me/avatar_default.png'" alt="歌手头像" />
          <span class="start-name-bg">{{ data.artist || "-" }}</span>
        </div>
        <div class="info-area">
          <div class="ellipsis">{{ data.songName || "-" }}</div>
          <p>发起类型: 翻唱</p>
          <p>翻唱量:</p>
          <p @click="go2WorkList">
            <span class="num"> {{ data.workscount }} </span>次 &gt;&gt;&gt;
          </p>
        </div>
      </div>
    </div>
    <div class="part part-two">
      <div class="left">
        <div class="btn" @click="go2WorkList">
          <img src="../assets/btn-see-others-cover.png" alt="看看他人翻唱" />
        </div>
      </div>
      <div class="right">
        <div class="btn" @click="goCover">
          <img src="../assets/btn-sing-cover.png" alt="翻唱这首歌" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGlobalParams, bridge, track, goTo } from "@changba/funny";

export default {
  name: "CoverTypeSong",
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    active: {
      type: Number,
      default() {
        return 0;
      },
    },
    homepageImg: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    icon() {
      return this.data.icon?.replace(/^http:\/\//i, "https:\/\/");
    },
    playing() {
      return this.$store.state.duetId === this.data.duetId;
    },
    authChecked() {
      return this.$store.state.authChecked;
    },
  },
  methods: {
    toggleSong() {
      if (this.playing) {
        this.$store.commit("pauseSongId");
      } else {
        this.$store.commit("playSongId", {
          duetId: this.data.duetId,
          originalMp3: this.data.original_mp3,
        });
      }
    },
    beforeAuthOpt() {
      return new Promise((resolve) => {
        if (!this.authChecked) {
          this.$openDialog(
            "AuthDialog",
            {},
            {
              auth: (state) => {
                resolve(!!state);
              },
            }
          );
        } else {
          resolve(true);
        }
      });
    },
    async handleClick() {
      const result = await this.beforeAuthOpt();
      if (!result) {
        return;
      }
      track("click_element_H5_ktv", {
        element_content: this.data.artist,
        element_content_ktv: "翻唱这首歌",
      });
      // 跳转到聚合页
      const songid = this.data.songid;
      goTo.soloRecordCover(songid);
    },
    async goCover() {
      const result = await this.beforeAuthOpt();
      if (!result) {
        return;
      }
      track("click_element_H5_ktv", {
        element_content: this.data.artist,
        element_content_ktv: "翻唱这首歌",
      });
      // 跳转到聚合页
      const songid = this.data.songid;
      // bridge.openPage("changba://?ac=musicdetail&duetid=" + songid);
      goTo.soloRecordCover(songid);
    },
    async go2WorkList() {
      track("click_element_H5_ktv", {
        element_content: this.data.artist,
        element_content_ktv: "看看他人翻唱",
      });
      const detail = {
        duetId: this.data.duetid,
        songid: this.data.songid,
        singer: this.data.artist,
        avatar: this.data.icon,
        songName: this.data.name,
        count: this.data.workscount,
        currentTab: this.active,
        homepageImg: this.homepageImg,
      };
      const params = await getGlobalParams();
      localStorage && localStorage.setItem(`${params.userId}_CurrentDuetInfo`, JSON.stringify(detail));
      this.$router.push({ path: "/detail" });
    },
  },
};
</script>

<style lang="scss" scoped>
.cover-type-song {
  padding: 0 0 50px 0;
  .part-one {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    .left {
      width: 376px;
      height: 376px;
      border-radius: 15px;
      background-image: url("../assets/cover-bg.png");
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      padding: 10px;
      margin-top: 47px;
      position: relative;

      .pic-area {
        width: 100%;
        height: 100%;
        border-radius: 15px;
        object-fit: contain;
      }

      .opt-icon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 94px;
        height: 94px;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
      }

      .icon-play {
        background-image: url("../assets/play-icon.png");
      }

      .icon-pause {
        background-image: url("../assets/pause-icon.png");
      }
    }

    .right {
      width: 282px;
      font-size: 25px;
      margin-left: 22px;
      display: flex;
      align-items: center;
      flex-direction: column;

      .avatar-area {
        width: 296px;
        height: 243px;
        background-image: url("../assets/avatar-bg.png");
        background-repeat: no-repeat;
        background-position: top left;
        background-size: cover;
        text-align: center;
        position: relative;

        .avatar {
          width: 133px;
          height: 133px;
          border-radius: 125px;
          top: 20px;
          left: 80px;
          position: absolute;
        }

        .start-name-bg {
          width: 180px;
          height: 70px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #fefdff;
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      .info-area {
        background-image: url("../assets/cover-type-info-bg.png");
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        width: 226px;
        height: 188px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #f7deff;
        display: flex;
        flex-direction: column;
        align-items: center;

        .ellipsis {
          text-align: center;
          white-space: nowrap;
          display: inline-block;
          width: 215px;
          overflow: hidden;
          margin-top: 25px;
          text-overflow: ellipsis;
          margin-bottom: 15px;
          flex-shrink: 0;
        }

        p {
          width: 180px;
          line-height: 1.5;
          margin-bottom: 2px;
          text-align: center;
        }

        .num {
          color: #ff71eb;
          font-weight: 600;
        }
      }
    }
  }

  .part-two {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 46px 40px 0 0;
    width: 100%;

    .btn {
      text-align: center;
      width: 282px;
      height: 100px;
      img {
        height: 100%;
      }
    }
  }
}
</style>
